<div *ngIf="!isSelfService()" class="container">
  <h5>Head Over to the Main Adnuntius Interface</h5>
  <p>This interface is designed specifically for users with fewer permissions than you possess.</p>
  <p>You have many more abilities available to you!</p>
  <p>
    Head over to <a href="https://admin.adnuntius.com/">admin.adnuntius.com</a> to gain access to the full range of
    features in our main interface.
  </p>
</div>
